import { useQuery } from '@tanstack/react-query';
import { getClinicalSiteRoles } from '../services/clinical_sites';

export const useClinicalSiteRoles = () => {
  return useQuery({
    queryKey: ['clinicalSiteRoles'],
    queryFn: getClinicalSiteRoles,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
}; 